import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import "./assets/css/variables.css";
import "./assets/css/main.css";
import AOS from 'aos'
import 'aos/dist/aos.css'
import 'bootstrap-icons/font/bootstrap-icons.css'


AOS.init()
createApp(App).use(store).use(router).mount("#app");
